import React from "react";
import moment from "moment";
import { FiAlertCircle } from "react-icons/fi";

function DeletedShipments({ shipments = [] }) {
  if (!shipments || shipments.length === 0) return null;

  return (
    <div className="mb-4">
      <p className="mb-1" style={{ fontSize: 13, fontWeight: 500 }}>
        Ištrinti transliavimai ({shipments.length})
      </p>
      {shipments.map((shipment) => {
        const trackings = shipment.courier_trackings || [];
        return (
          <div
            key={shipment.id}
            className="mb-2"
            style={{
              padding: "8px 10px",
              borderRadius: 2,
              border: "1px solid #e0e0e0",
              backgroundColor: "#fafafa",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <span className="text-xs" style={{ color: "#6c757d" }}>
                {(shipment.shipment_type || "").toUpperCase()}
                {shipment.pickup_address_code
                  ? ` · ${shipment.pickup_address_code}`
                  : ""}
              </span>
              <span className="text-xs" style={{ color: "#6c757d" }}>
                Ištrinta:{" "}
                {shipment.deleted_at
                  ? moment(shipment.deleted_at).format("YYYY-MM-DD HH:mm")
                  : "-"}
              </span>
            </div>

            {shipment.external_order_number && (
              <p className="mb-0 text-xs text-black mt-1">
                EN: {shipment.external_order_number}
              </p>
            )}

            {trackings.length > 0 && (
              <div
                className="d-flex flex-column mt-2"
                style={{
                  padding: "8px 8px 5px",
                  borderRadius: 2,
                  backgroundColor: "#f8d7da",
                }}
              >
                <div className="d-flex align-items-center">
                  <FiAlertCircle
                    className="text-danger mr-1"
                    style={{ fontSize: 12 }}
                  />
                  <span
                    style={{
                      color: "#842029",
                      fontWeight: 400,
                      fontSize: 10,
                      lineHeight: 1,
                    }}
                  >
                    Turi kurjerio numerį - prekės gali būti pajudėjusios
                  </span>
                </div>
                {trackings.map((courier) => (
                  <a
                    key={courier.number}
                    className="text-black mb-0 text-xs font-normal mt-1"
                    style={{ pointerEvents: "all" }}
                    href={courier.url}
                    target="_blank"
                  >
                    <u>{courier.number}</u>
                  </a>
                ))}
              </div>
            )}

            <div className="d-flex justify-content-between mt-1">
              {shipment.picked_up_at && (
                <span className="text-xs" style={{ color: "#6c757d" }}>
                  Picked up: {moment(shipment.picked_up_at).format("YYYY-MM-DD HH:mm")}
                </span>
              )}
              {shipment.delivered_at && (
                <span className="text-xs" style={{ color: "#6c757d" }}>
                  Delivered:{" "}
                  {moment(shipment.delivered_at).format("YYYY-MM-DD HH:mm")}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default DeletedShipments;
